import React from 'react';
import { Icon, ExpandableSection } from '@amzn/awsui-components-react/polaris';
import { Link } from 'react-router-dom';

export const FILTERING_FIELDS = [
  "challengeId" ,
  "name",
  "primaryOwner",
  "type"
];

export function getColumnDefinition(basepath=''){
  return [{
    id: 'challengeId',
    header: () => 'Challenge ID',
    cell: challenge => <div><Link to={basepath+`/${challenge.challengeId}`}> {challenge.challengeId} </Link></div>,
    minWidth: '120px',
    allowLineWrap: true
  }, 
  {
    id: 'challengeType',
    header: () => 'Type',
    cell: challenge => `${challenge.type}`,
    minWidth: '110px',
    allowLineWrap: true
  },
  {
    id: 'challengeName',
    header: () => 'Challenge name',
    cell: challenge => <div><Link to={basepath+`/${challenge.challengeId}`}> {challenge.name} </Link></div>,
    minWidth: '300px',
    allowLineWrap: true
  }, {
    id: 'difficultyLevel',
    header: () => 'Difficulty',
    cell: challenge => `${challenge.difficultyLevel}`,
    minWidth: '95px',
    allowLineWrap: true
  }, {
    id: 'timeAllotted',
    header: () => 'Time Allotted',
    cell: challenge => `${((challenge.timeAllotted) / 60000).toFixed(2)} minutes`,
    minWidth: '150px',
    allowLineWrap: true
  },{
    id: 'primaryOwner',
    header: () => 'Primary Owner',
    cell: challenge => challenge.primaryOwner,
    minWidth: '100px',
    allowLineWrap: true
  }];
}

export const SORTABLE_COLUMNS = [
  {id: 'challengeId', field: 'challengeId'},
  {id: 'challengeType', field: 'type'},
  {id: 'challengeName', field: 'challengeName'},
  {id: 'difficultyLevel', field: 'difficultyLevel'},
  {id: 'timeAllotted', field: 'timeAllotted'},
  {id: 'primaryOwner', field: 'primaryOwner'},
];

export const CONTENT_SELECTOR_OPTIONS = [{
  label: 'Challenges',
  options: [
    {id: 'challengeId', label: 'Challenge ID', editable: true, visible: true},
    {id: 'challengeType', label: 'Type', editable: true, visible: true},
    {id: 'challengeName', label: 'Challenge name', editable: false, visible: true},
    {id: 'difficultyLevel', label: 'Difficulty level', editable: true, visible: true},
    {id: 'primaryOwner', label: 'Primary Owner', editable: true, visible: false},
    {id: 'timeAllotted', label: 'Time Allotted', editable: true, visible: false},
  ]
}];

export const PAGE_SELECTOR_OPTIONS = [
  {value: 10, label: '10 Challenges'},
  {value: 30, label: '30 Challenges'},
  {value: 50, label: '50 Challenges'}
];

export const CUSTOM_PREFERENCE_OPTIONS = [
  {value: 'table', label: 'Table'},
  {value: 'cards', label: 'Cards'}
];

export function getAttemptedChallengeTableDefinition(basepath=''){
  return [{
    id: 'attemptID',
    header: () => 'Attempt ID',
    cell : item => item.attemptId,
    minWidth: '100px',
    allowLineWrap: true
  }, {
    id: 'startTime',
    header: () => 'Start Time',
    cell : item => `${item.challengeStartTime !== undefined ? (new Date(Number(item.challengeStartTime))).toLocaleString() : '-' }`,
    minWidth: '100px',
    allowLineWrap: true
  }, {
    id: 'gameStatus',
    header: () => 'Status',
    cell : item => {
        let statusClass, iconClass, statusText;
        if(item.attemptStatus === "PROVISION_IN_PROGRESS") {
            statusClass = "awsui-util-status-info";
            iconClass = "status-pending";
            statusText = "Provisioning";
        }
        else if(item.attemptStatus === "PROVISION_COMPLETE") {
            statusClass = "awsui-util-status-info";
            iconClass = "status-stopped";
            statusText = "Provision Complete";
        }
        else if(item.attemptStatus === "PROVISION_FAILED" || item.attemptStatus === "VALIDATION_FAILED") {
            statusClass = "awsui-util-status-negative";
            iconClass = "status-negative";
            statusText = "Terminated";
        }
        else if(item.attemptStatus === "ATTEMPT_IN_PROGRESS") {
            statusClass = "awsui-util-status-info";
            iconClass = "status-in-progress";
            statusText = "Ongoing";
        }
        else if(item.attemptStatus === "VALIDATION_IN_PROGRESS") {
            statusClass = "awsui-util-status-info";
            iconClass = "status-pending";
            statusText = "Validating";
        }
        else {
            if(item.score !== undefined && item.score !== null){
                statusClass = "awsui-util-status-positive";
                iconClass = "status-positive";
                statusText = "Complete";
            }
            else {
                statusClass = "awsui-util-status-negative";
                iconClass = "status-negative";
                statusText = "Terminated";
            }
        }
        return (
            <div className={statusClass}>
                <Icon name={iconClass}/>
                <span> {statusText}</span>
            </div>
        )
    },
    minWidth: '100px',
    allowLineWrap: true
  }, {
    id: 'Score',
    header: () => 'Score',
    cell : item => {
        return (<ExpandableSection
            header={`${item.score !== undefined ? JSON.stringify(parseInt(item.score.totalScore,10)) : "N/A"}`}
            content={`${item.score !== undefined ? JSON.stringify(item.score.splitScore) : "N/A"}`}
            variant="navigation"
          ></ExpandableSection>);
    },
    minWidth: '150px',
    allowLineWrap: true
  },{
      id: 'Passing Score',
      header: () => 'Passing Score',
      cell : item => `${item.passPercentage !== undefined ? item.passPercentage : '-' }`,
      minWidth: '100px',
      allowLineWrap: true
  }, {
      id: 'Result',
      header: () => 'Result',
      cell : item => {
          if (item.score === undefined || item.score.passed === undefined) {
              return (
                  <span>{'-'}</span>
              )
          }
          else {
              if (item.score.passed === "true") {
                  return (
                      <div className={"awsui-util-status-positive"}>
                          <Icon name={"status-positive"}/>
                          <span> {"Passed"}</span>
                      </div>
                  )
              }
              else {
                  return (
                      <div className={"awsui-util-status-negative"}>
                          <Icon name={"status-negative"}/>
                          <span> {"Failed"}</span>
                      </div>
                  )
              }
          }
      }
  }];
}



// WEBPACK FOOTER //
// ./src/app/res/TableConfig.jsx